import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import {
  FormControl,
  Grid,
  FormLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  TextField,
  Checkbox,
  MenuItem,
} from '@mui/material';
import Swal from 'sweetalert2';

import { Modal } from '../../../components/BootstrapToMUI';
import request from '../../../services/Request';

export default function AddNewMemberModal(props) {
  const { user, setReflesh, reflesh, id, setMobile, ...rest } = props;

  const defaultValues = {
    name: '',
    email: '',
    phone: '',
  };
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm(defaultValues);

  const watchall = watch();

  useEffect(() => {
    if (props.show) {
      reset(defaultValues);
    }
  }, [props.show]);

  const handleSignUp = (formData) => {
    const password = Math.random().toString(36).slice(-8);

    const obj = {
      username: formData.name,
      email: formData.email,
      phone: formData.phone,
      id: id,
      password: password,
    };

    if (
      id === 'tianlangwu001@gmail.com' ||
      id === 'shivangum@alpskiosks.com' ||
      id === 'rachel@potere.us'
    ) {
      obj.pinOnly = true;
    }

    // return console.log('obj', obj);
    request({
      method: 'post',
      url: `/signupClientUser`,
      data: obj,
    })
      .then((res) => {
        Swal.fire({
          title: 'Success',
          text: 'Member has been successfully created',
        }).then(() => {
          props.onHide();
          setReflesh(!reflesh);
        });
      })
      .catch((err) => {
        console.log(err.response);
        Swal.fire({
          text: err.response?.data?.error?.message || 'Something went wrong',
          icon: 'error',
        });
      })
      .finally(() => {});
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Create New Member</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <form
          onSubmit={handleSubmit(handleSignUp)}
          noValidate
          style={{ textAlign: 'center', padding: '0 40px' }}
        >
          <div className="mb-4">
            <TextField
              label="User Name"
              fullWidth
              required
              {...register('name', { required: 'Name is required' })}
            />
          </div>
          <div className="mb-4">
            <TextField
              label="Email"
              type="email"
              fullWidth
              required
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value:
                    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                  message: 'Please enter a valid email',
                },
              })}
            />
          </div>
          {errors.email && <p className="signUpErrorMessage">{errors.email.message}</p>}
          <div className="mb-4">
            <TextField
              label="Phone Number"
              type="phone"
              fullWidth
              {...register('phone', {
                required: 'Email is required',
                pattern: {
                  value: /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                  message: 'Please enter a valid phone number',
                },
              })}
            />
          </div>
          {errors.phone && <p className="signUpErrorMessage">{errors.phone.message}</p>}

          <div>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Sign Up
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
